import { render, staticRenderFns } from "./BillingAddress.vue?vue&type=template&id=24cb70fd"
import script from "./BillingAddress.vue?vue&type=script&lang=js"
export * from "./BillingAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports